import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { Education } from '../../applicant-service/service-models/education';
import { EducationHistoryConfiguration } from '../../job-service/service-models/education-history-configuration';

@Component({
  selector: 'app-education',
  templateUrl: './education.component.html',
  styleUrls: ['./education.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class EducationComponent implements OnInit {
  @Input()
  education: Education;
  @Input()
  configuration: EducationHistoryConfiguration;
  @Input()
  index: number;
  @Output()
  remove = new EventEmitter();
  disableToDate: boolean;
  @ViewChild('toDateInput') toDateInput: ElementRef;

  constructor() { }

  ngOnInit() {
    this.education = this.education || new Education();
    this.configuration = this.configuration || new EducationHistoryConfiguration();
    this.disableToDate = this.education.currentlyAttending;
  }

  onEndDateChanged($event) {
    const changedDate = this.parseDateString($event);

    if (changedDate !== undefined) { this.education.endDate = changedDate; }
  }

  onStartDateChanged($event) {
    const changedDate = this.parseDateString($event);

    if (changedDate !== undefined) { this.education.startDate = changedDate; }
  }

  parseDateString($event: string): Date {
    const dateParts = $event.split('/');

    if (dateParts.length !== 2 || dateParts[1].length < 4 || dateParts[0].length < 2 || (isNaN(+dateParts[1]) || isNaN(+dateParts[0]))) {
      return undefined;
    }

    return new Date(+dateParts[1], +dateParts[0] - 1);
  }

  onCurrentlyAttendingChange() {
    if (this.education.currentlyAttending) {
      this.education.endDate = null;
      this.toDateInput.nativeElement.value = '';
      this.disableToDate = true;
    } else {
      this.disableToDate = false;
    }
  }
}
